import * as types from './types';
import { loading } from 'State/actions';

export const getServedItems = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.getGeneric('ServedItem');
      dispatch({
        type: types.SITESETUP_GET_SERVED_ITEMS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.SITESETUP_GET_SERVED_ITEMS_ERROR,
        payload: error.response,
      });
    }
  };
};

export const getServedItemsNutrition = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SITESETUP_SERVED_ITEMS_NUTRITION_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('ServedItem/NutritionCode');
      dispatch({
        type: types.SITESETUP_GET_SERVED_ITEMS_NUTRITION,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: types.SITESETUP_GET_SERVED_ITEMS_NUTRITION_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.SITESETUP_SERVED_ITEMS_NUTRITION_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/servedItems/actions.js